<template lang="pug">
	.form-group.fg-advertiser
		.d-flex.justify-content-between
			label Advertiser ({{ visibleAdvertiserOptions.length }})
				b-checkbox(switch="", v-model="advertiserOptionsArchive")
			button.btn(id="popover-legal-adv", ref="button", :style="legalAvailable ? 'padding: 0 5px' : 'display: none'", type="button")
				i.la.la-gavel.text-muted
		multiselect(:multiple="multiple", :options="visibleAdvertiserOptions",
			:value="value", @input="onChange",
			track-by="v", label="t", deselect-label="", select-label="", :show-labels="multiple")
		b-popover(target="popover-legal-adv", triggers="click", :show.sync="popoverShow", placement="auto", container="my-container", ref="popover")
			template(#title)
				b-button(@click="onClosePopover", class="close", aria-label="Close")
					span.d-inline-block(aria-hidden="true") &times;
				| Legal Entity
			.form-group.no-label
				multiselect(:multiple="false", :options="legalOptions", :value="legal_entity_id", track-by="v", label="t", deselect-label="", select-label="", @input="selectLegal")

</template>
<script>
import Vue from 'vue';

export default {
  name: 'SelectAdvertiser',
  props: {
    value: {
      type: [Array],
    },
    multiple: {
      type: [Boolean],
      default() {
        return true;
      },
    },
  },
  computed: {
    visibleAdvertiserOptions() {
      return this.advertiserOptions.filter((a) => {
        return this.advertiserOptionsArchive || a.status;
      });
    },
  },
  data() {
    return {
      advertiserOptions: [],
      advertiserOptionsArchive: false,
      legalOptions: [],
      legal_entity_id: null,
      legalAvailable: false,
      popoverShow: false,
    };
  },
  methods: {
    onChange(value) {
      this.$emit('input', value);
    },
    selectLegal(legal) {
      let selected = this.advertiserOptions.filter((o) => o.legal_entity_id === legal.v);
      this.$emit('input', selected);
      this.popoverShow = false;
    },
    onClosePopover() {
      this.popoverShow = false;
    },
  },
  async mounted() {
    this.advertiserOptions = await Vue.ovData.advertiser.getOptions(true);
    this.legalOptions = await Vue.ovData.legalEntity.getOptions(true);
    this.legalAvailable = this.legalOptions.length > 0;
  },
};
</script>
